import React from 'react';
import ProcessingInProressHeader from './component/Header';
import ProcessingInProgressList from './component/ProcessingInProgressList';
import {ReportScreenTabTypes} from '../../pages/reports/ProjectOverview';

interface Props {
  openSpecificTab?: (type: ReportScreenTabTypes) => void;
}
const ProcessingInSummaryTab: React.FC<Props> = ({openSpecificTab}) => {
  return (
    <>
      <ProcessingInProressHeader openSpecificTab={openSpecificTab} />
      <ProcessingInProgressList openSpecificTab={openSpecificTab} />
    </>
  );
};

export default ProcessingInSummaryTab;
